import * as React from 'react';
import { Section } from '../Section';
import { IMortgageProps } from './types';

interface IMortgageDesktopProps extends IMortgageProps {
  banner: React.ReactNode;
  title: string;
}

export const Mortgage: React.FC<IMortgageDesktopProps> = ({ fields, programs, banner, title }) => {
  return (
    <Section title={title} dataName="Mortgage">
      {fields}
      {programs}
      {banner}
    </Section>
  );
};
